import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { API_URL } from '../../config';

const style = {
    height: 200,
    margin: 20,
    textAlign: 'left',
    display: 'inline-block'
};

const padding = {
    padding: 10
}

const border = {
    border: '2px solid red',
    margin: '50px',
}

const getBankIp = async () => {
    const res = await axios.get(API_URL+`/kontoip`)
    return res.data;
};

const BankIpComponent = () => {
  const [skrot, setSkrot] = useState('');
  const [status, setStatus] = useState(false);

  useEffect(() => {
    getBankIp().then(bankData => {
       if(bankData.data && bankData.data.skrot) setSkrot(bankData.data.skrot);
        setStatus(bankData.status);
    });
  }, []);

  return (
      <div style={border}>
          {status &&
            <div>
                <h2>Konto do opłat dokonywanych od 1.01.2021 r.</h2>
                {skrot === 'DS project' &&
                    <div style={style}>
                        <div style={padding}><strong>Nazwa operatora: DS Project Damian Siwek</strong></div>
                        <div style={padding}><strong>Numer konta (Bank Pekao): 79 1240 5370 1111 0011 0294 3819</strong></div>
                    </div>}
                {skrot !== 'DS project' && <div style={padding}><strong>BEZ ZMIAN</strong></div>}
          </div>}
          {!status && <h2>Aby sprawdzić numer konta do opłat, połącz się z routerem podłączonym do sieci HiSpeed.pl</h2>}
      </div>
  );
}

export default BankIpComponent;


// WEBPACK FOOTER //
// ./src/components/Bank/BankIpComponent.js